module.exports = __webpack_public_path__ + "img/general-service.5c6cda63.jpg";